import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import LazyImage from '../../gui/lazyImage';

function imageSrc(image = {}) {
    return image.s3MediumLink || image.s3SmallLink || image.s3Link || '';
}

/** Greeting door: title, body, pictures and an optional link. Also the base of the sponsor door. */
@observer
class AdventTextDoor extends Component {
    render() {
        const { door = {}, children } = this.props;
        const content = door.content || {};
        return (
            <div>
                {content.title ? <div class='fs-5 fw-bold mb-2'>{content.title}</div> : null}
                {(content.images || []).filter(img => imageSrc(img)).map(img => (
                    <div key={`advent-img-${img.md5 || img.s3Link}`} class='mb-3 rounded overflow-hidden'>
                        <LazyImage src={imageSrc(img)} lowResBase64={img.lowResBase64} alt={content.title || ''} />
                    </div>
                ))}
                {content.body ? <div class='mb-3' style='white-space: pre-wrap;'>{content.body}</div> : null}
                {children}
                {content.link ? (
                    <a href={content.link} target='_blank' rel='noopener noreferrer' class='btn btn-outline-primary'>
                        <i class='fa-solid fa-arrow-up-right-from-square me-2' />
                        {content.linkText || content.link}
                    </a>
                ) : null}
            </div>
        );
    }
}

export default AdventTextDoor;
